"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = __importDefault(require("react"));
const spinner_icon_1 = require("./icons/spinner-icon");
const Spinner = (props) => react_1.default.createElement(spinner_icon_1.SpinnerIcon, Object.assign({}, props));
exports.Spinner = Spinner;
